import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b30180a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "steps" }
const _hoisted_2 = { class: "step-inner" }
const _hoisted_3 = { class: "step-order" }
const _hoisted_4 = ["innerHTML"]

import { withDefaults } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    list: null,
    height: null,
    width: null
  },
  setup(__props: any) {

const props = __props as { list?: string[], height: number, width: number }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "step-item-content",
        key: index
      }, [
        _createElementVNode("div", {
          class: "step-item",
          style: _normalizeStyle({ width: __props.width + 'px', height: __props.height + 'px' })
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(("0" + (index + 1)).slice(-2)), 1),
            _createElementVNode("p", {
              class: "step-content",
              innerHTML: item
            }, null, 8, _hoisted_4)
          ])
        ], 4),
        (index != __props.list.length - 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["arrow", __props.list.length >= 4 ? 'arrow-sp' : ''])
            }, null, 2))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})